import React, { useState } from "react";
import { Input } from "./ui/input";

/**
 * Password field with a "Show"/"Hide" link on the right so people can
 * check what they typed. Drop-in replacement for <Input type="password">.
 */
const PasswordInput = ({ style, ...props }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        style={{ ...style, paddingRight: "56px" }}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : "password-toggle"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-sm underline hover:no-underline"
        style={{
          color: "#51120A",
          background: "none",
          border: "none",
          cursor: "pointer",
          fontFamily: "'Bricolage Grotesque', sans-serif",
        }}
      >
        {visible ? "Hide" : "Show"}
      </button>
    </div>
  );
};

export default PasswordInput;
